import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent, Divider,
    Popper,
    Grow,
} from '@material-ui/core';
import { TRIP_TRANSACTION_FILTER_LIST } from '../../../store/constants';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    filterButtonVehicle: {
        textTransform: "capitalize",
        padding: "5px 10px",
        backgroundColor: "#fff",
        fontWeight: 300,
        paddingLeft: 16,
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'flex-start', fontWeight: 300, paddingTop: 10, paddingBottom: 10, textTransform: 'capitalize'
    },
}));

const PaymentTabFilter = ({ filterValue, user }) => {

    const [open, setOpen] = useState(false);
    const [selectedFilterDisplayName, setSelectedFilterDisplayName] = useState("Trips & Payments");
    const [transactFilterList, setTransactFilterList] = useState([]);

    const anchorRef = useRef(null);
    const prevOpen = useRef(open);

    const classes = useStyles();

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, []);

    useEffect(() => {

        // ******************************************* For Passbook tab supplier. ********************************************
        if (user && user.supplierTransactionLog && user.supplierTransactionLog.transactionEvents) {
            setTransactFilterList(user.supplierTransactionLog.transactionEvents);
        } else {
            setTransactFilterList(TRIP_TRANSACTION_FILTER_LIST);
        }

    }, [user.supplierTransactionLog]);

    const handleFilterOpen = () => {
        setOpen(true)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const handleItemClick = (value) => {
        setOpen(false);
        setSelectedFilterDisplayName(value.displayName);
        filterValue(value.value);
    }

    return (
        <>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                variant="outlined"
                size="small"
                className={classes.filterButtonVehicle}
                onClick={handleFilterOpen}
            >
                {selectedFilterDisplayName}{" "}
                <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
            </Button>


            {
                open &&
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow">

                                        {/* Date Filter for reports. */}
                                        {transactFilterList && transactFilterList.length > 0 && transactFilterList.map((value, index) => (

                                            < div className={classes.wV1} >
                                                < MenuItem key={index} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{value.displayName}</MenuItem>
                                                <Divider light />
                                            </ div>
                                        ))}

                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }
        </>
    );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTabFilter);